import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DELIVERY_KINDS, DELIVERY_STATES, RANGES } from '@/features/activity/deliveries/api';
import { AllDeliveriesPage } from '@/features/activity/deliveries/deliveries-page';

// S19 · Deliveries (07 §5). Filters `?state=` `?kind=` `?cause=` `?carrier=` `?range=` (default today);
// `?row=<id>` opens a payload or note below the table, `?view=diff` its diff with the previous revision.
export const Route = createFileRoute('/_app/activity/deliveries')({
  validateSearch: z.object({
    state: z.enum(DELIVERY_STATES).optional().catch(undefined),
    kind: z.enum(DELIVERY_KINDS).optional().catch(undefined),
    cause: z.string().max(64).optional().catch(undefined),
    carrier: z.string().max(64).optional().catch(undefined),
    range: z.enum(RANGES).optional().catch(undefined),
    row: z.string().max(64).optional().catch(undefined),
    view: z.enum(['json', 'diff']).optional().catch(undefined),
  }),
  component: AllDeliveriesPage,
});
